import React from 'react'
import { connect } from 'react-redux'
import i18next from 'i18next'
import * as PIXI from 'pixi.js'
import Config from 'config'
import Currency from 'macguffin/Utils/Currency'
import {
  increaseBet,
  decreaseBet,
  openSettingsScreen,
} from 'macguffin/redux/actions'
import { uiButtonPressed, setPopupScreen } from '../../redux/actions'

import {
  INCREASE_BET,
  DECREASE_BET,
  POPUP_SCREENS,
  BUTTON_CLOSE,
} from '../../redux/constants'
import SvgIcon from '../svg/SvgIcon'

@connect(
  state => ({
    paused: state.base.paused,
    playing: state.base.playing,
    allowSpinRequests: state.base.allowSpinRequests,
    currencySign: state.session.currencySign,
    canDecrease: state.session.canDecrease,
    canIncrease: state.session.canIncrease,
    forcedBet: state.session.forcedBet,
    popupScreen: state.UI.popupScreen,
    autoPlay: state.autoPlay,
  }),
  {
    increaseBet,
    decreaseBet,
    uiButtonPressed,
    setPopupScreen,
    openSettingsScreen,
  }
)
export default class BetArea extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      betTogglerHovered: false
    }
  }

  forceGameRender = () => {
    const { paused } = this.props
    if (paused) {
      setTimeout(() => PIXI.Ticker.shared.update())
    }
  }

  onDecrease = enabled => {
    if (enabled) {
      this.props.decreaseBet()
      this.forceGameRender()
      this.props.uiButtonPressed(DECREASE_BET)
    }
  }

  onIncrease = enabled => {
    if (enabled) {
      this.props.increaseBet()
      this.forceGameRender()
      this.props.uiButtonPressed(INCREASE_BET)
    }
  }

  openPopup = () => {
    if (!this.props.playing) {
      this.props.setPopupScreen(this.props.popupScreen === POPUP_SCREENS.BET ? null : POPUP_SCREENS.BET)
      uiButtonPressed(this.props.popupScreen === POPUP_SCREENS.BET ? BUTTON_CLOSE : POPUP_SCREENS.BET)
    }
  }

  render() {
    const { props, onIncrease, onDecrease, state } = this
    const {
      currencySign,
      value,
      playing,
      allowSpinRequests,
      canIncrease,
      canDecrease,
      forcedBet,
      popupScreen,
      svgIcons,
      autoPlay: { autoPlaying },
      formatStyle,
    } = props

    const { betTogglerHovered } = state

    const decreaseEnabled = !playing && canDecrease && !forcedBet && !autoPlaying
    const increaseEnabled = !playing && canIncrease && !forcedBet && !autoPlaying

    const valueProps = {
      className: 'text'
    }

    let sizeClass = ''
    const betValue = Currency.format(value, formatStyle)
    if (betValue.length > 10) {
      sizeClass = 'bigValue'
    }

    const betLabel = i18next.t('gameControl.bet')

    let labelClass = ''
    if (betLabel && currencySign && betLabel.length + currencySign.length > 12) {
      labelClass = 'bigText'
    }

    const { desktopUI, portrait } = this.props.dimensions
    if (!desktopUI && !portrait && (sizeClass || labelClass)) {
      sizeClass = 'bigValue'
      labelClass = 'bigText'
    }

    const betPopupVisible = popupScreen === POPUP_SCREENS.BET

    const quickspinEnabled = Config.FEATURE_CONFIG.QUICKSPIN

    return (
      <div className={`bet info ${quickspinEnabled ? '' : 'no-quickspin'}`}>
        <div className={`bg-field ${betPopupVisible || betTogglerHovered ? 'active' : ''}`} />
        <div className={`infoArea bet ${sizeClass}`}>
          <SvgIcon
            svgIcons={svgIcons}
            additionalClass="bet-decrease"
            disabled={!decreaseEnabled}
            iconName="minus"
            hasClickIcon={true}
            onClick={() => onDecrease(decreaseEnabled)}
            holdButtonEnabled={true}
          />
          <span {...valueProps}>{betValue}</span>
          <SvgIcon
            svgIcons={svgIcons}
            additionalClass="bet-increase"
            disabled={!increaseEnabled}
            iconName="plus"
            hasClickIcon={true}
            onClick={() => onIncrease(increaseEnabled)}
            holdButtonEnabled={true}
          />
        </div>
        <div className={`labels ${labelClass}`}>
          <div className="label bet">{betLabel}</div>
          <div className="label currency">{currencySign}</div>
        </div>
        <div
          className={`bet-popup-toggler ${(playing || autoPlaying || !allowSpinRequests) ? 'disable' : ''}`}
          onClick={this.openPopup}
          onMouseEnter={() => !playing && !autoPlaying && this.setState({ betTogglerHovered: true })}
          onMouseLeave={() => this.setState({ betTogglerHovered: false })}
        />
      </div>
    )
  }
}
